<template>
  <div class="color-sample n1-east">
    <section>
      <p class="small-text">
        十二月二十八日
      </p>
    </section>
    <section>
      <p class="default-text">
        武皇嘯厚大禅門
      </p>
    </section>
    <section>
      <p class="small-text">
        令和元年
      </p>
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";
</style>
